<template>
  <div>
    <vca-row>
      <vca-card v-if="options" class="shadowed">
        <vca-field :label="$t('profile.settings.header_member')">
          <ActiveFlag v-if="options.includes('active')" />
          <br />
          <NonvotingMembership v-if="options.includes('nvm')" />
        </vca-field>
        <vca-field
          v-if="options.includes('volunteer_cert')"
          :label="$t('profile.certificate.header')"
        >
          <Certificate />
        </vca-field>
      </vca-card>
      <vca-card class="shadowed">
        <vca-field :label="$t('profile.settings.header_roles')">
          <Roles />
        </vca-field>
        <Change />
      </vca-card>
    </vca-row>
  </div>
</template>

<script>
import ActiveFlag from "@/components/account/settings/ActiveFlag";
import Certificate from "@/components/account/settings/Certificate";
import Change from "@/components/account/settings/Change";
import NonvotingMembership from "@/components/account/settings/NonvotingMembership";
import Roles from "@/components/account/settings/Roles";
import { mapGetters } from "vuex";
export default {
  name: "AccountSettings",
  components: {
    Change,
    NonvotingMembership,
    ActiveFlag,
    Roles,
    Certificate,
  },
  computed: {
    ...mapGetters({
      options: "organisations/options",
    }),
  },
};
</script>
